import API from './api'

export const getVets = async () => {
  const {
    data: { vets = '' },
  } = await API.get('employees/vets/search')

  return vets
}
